// data/about-heritage.ts

export interface AboutHeritageContent {
  headline: {
    segments: HeadlineSegment[];
  };
  body: {
    intro: string;
    brandName: string;
    outro: string;
  };
  accentLink: {
    label: string;
    href: string;
  };
  inquiry: {
    eyebrow: string;
    description: string;
    phone: string;
    phoneDisplay: string;
  };
  cta: {
    label: string;
    href: string;
  };
  image: {
    src: string;
    alt: string;
  };
}

export type HeadlineSegment =
  | { type: "normal"; text: string }
  | { type: "muted"; text: string }
  | { type: "serif"; text: string };

export const ABOUT_HERITAGE_CONTENT: AboutHeritageContent = {
  headline: {
    segments: [
      {
        type: "normal",
        text: "Great products don't begin with machines.",
      },
      {
        type: "muted",
        text: "They begin with the courage",
      },
      {
        type: "normal",
        text: "to accept challenges and engineer",
      },
      {
        type: "serif",
        text: "exceptional craftsmanship.",
      },
    ],
  },

  body: {
    intro: "At",
    brandName: "The Quality Collection",
    outro:
      ", we believe every remarkable idea deserves an exceptional manufacturing partner. While many suppliers focus on standard production, we specialize in custom developments that demand creativity, precision, technical expertise, and uncompromising quality. With experience across more than 20 handcrafted product categories, we work seamlessly with Brass, Copper, Stainless Steel, Iron, Aluminum, Wood, Marble, Glass, Resin, Leather, and mixed-material constructions to transform concepts into world-class products. Whether you begin with a hand sketch, a 3D drawing, a reference image, or simply an idea, our team collaborates closely with you to create products that reflect your brand and exceed international quality standards. We don't begin by asking whether something can be made—we ask how it can be made better. Every detail, finish, and shipment reflects our commitment to helping global brands reduce sourcing risks, simplify development, and build distinctive collections that stand out in today's competitive marketplace.",
  },

  accentLink: {
    label: "Let's create something extraordinary together.",
    href: "/contact",
  },

  inquiry: {
    eyebrow: "Direct Inquiries",
    description:
      "Connect with our product development and export specialists.",
    phone: "",
    phoneDisplay: "",
  },

  cta: {
    label: "Learn More",
    href: "/about",
  },

  image: {
    src: "/aboutimages/company-tour-img.webp",
    alt: "Expert artisan crafting premium handcrafted products for global export",
  },
};

/* ────────────────────────────────────────────────────────────── */
/* Colors for headline scroll-fill animation */
/* ────────────────────────────────────────────────────────────── */

export const HEADLINE_COLORS = {
  initial: "#e7e5e4",      // stone-200
  normalFinal: "#1c1917",  // stone-900
  mutedFinal: "#78716c",   // stone-500
  serifFinal: "#92400e",   // amber-800
} as const;